import React, { useState, useEffect } from "react";
import { Form, Grid, Button } from "tabler-react";
import Select from "react-select";
import Axios from "axios";
import { api_raiz } from "../../../config/config";
import { NotificationManager } from "react-notifications";

const ModalMovimientoPatio = ({ idMovimiento, remolquesTipo, cerrarModal }) => {
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [patioId, setPatioId] = useState(null);
  const [enProtocolo, setEnProtocolo] = useState(false);

  const [modelot, setModelot] = useState("");
  const [marcat, setMarcat] = useState("");
  const [colort, setColort] = useState("");
  const [placat, setPlacat] = useState("");
  const [economicot, setEconomicot] = useState("");
  const [placar, setPlacar] = useState("");
  const [economicor, setEconomicor] = useState("");
  const [observaciones, setObservaciones] = useState("");
  const [nombreOperador, setNombreOperador] = useState("");
  const [medioContacto, setMedioContacto] = useState("");
  const [licencia, setLicencia] = useState("");
  const [contenedorSize, setContenedorSize] = useState({ value: 0, label: "Selecciona tipo de plataforma" });

  useEffect(() => {
    if (!idMovimiento) { setLoading(false); return; }
    Axios.get(`${api_raiz}movimientosPatio/idMovimiento/${idMovimiento}`)
      .then((res) => {
        if (res.data && res.data.id) {
          const p = res.data;
          setPatioId(p.id);
          setEnProtocolo(p.enProtocolo || false);
          setModelot(p.tractorModelo || "");
          setMarcat(p.tractorMarca || "");
          setColort(p.tractorColor || "");
          setPlacat(p.tractorPlaca || "");
          setEconomicot(p.economicot || "");
          setPlacar(p.remolquePlaca || "");
          setEconomicor(p.economicor || "");
          setObservaciones(p.observaciones || "");
          setNombreOperador(p.operadorNombre || "");
          setMedioContacto(p.operadorContacto || "");
          setLicencia(p.operadorLicencia || "");
          if (p.idRemolque && remolquesTipo) {
            const found = remolquesTipo.find((r) => r.value === p.idRemolque.idRemolque);
            if (found) setContenedorSize(found);
          }
        }
      })
      .catch(() => {})
      .finally(() => setLoading(false));
  }, [idMovimiento]);

  const guardar = async () => {
    if (!modelot || !marcat || !colort || !placat || !economicot || !placar || !economicor || !nombreOperador || !medioContacto || !contenedorSize.value) {
      NotificationManager.warning("Completa todos los campos obligatorios", "Atención");
      return;
    }
    setSaving(true);
    const obj = {
      ...(patioId ? { id: patioId } : {}),
      idMovimiento,
      idRemolque: { idRemolque: contenedorSize.value },
      operadorNombre: nombreOperador,
      operadorContacto: medioContacto,
      operadorLicencia: licencia,
      tractorModelo: modelot,
      tractorMarca: marcat,
      tractorColor: colort,
      tractorPlaca: placat,
      remolquePlaca: placar,
      observaciones,
      economicot,
      economicor,
      enProtocolo,
    };
    try {
      if (patioId) {
        await Axios.put(`${api_raiz}movimientosPatio`, obj);
      } else {
        await Axios.post(`${api_raiz}movimientosPatio`, obj);
      }
      NotificationManager.success(
        patioId ? "Datos actualizados correctamente" : "Datos registrados correctamente",
        "Éxito"
      );
      if (cerrarModal) cerrarModal();
    } catch (error) {
      console.error("Error al guardar movimientosPatio:", error);
      NotificationManager.error("Error al guardar datos de unidad y operador", "Error");
    } finally {
      setSaving(false);
    }
  };

  if (loading) return <div className="text-center p-5">Cargando...</div>;

  const field = (label, value, setter, required = true, placeholder = "") => (
    <div className="col col-12 col-sm-12 col-md-4">
      <Form.Group label={<div>{label}{required && <label className="font-weight-bold text-danger">*</label>}</div>}>
        <Form.Input
          value={value}
          onChange={(e) => setter(e.target.value.toUpperCase())}
          style={{ textTransform: "uppercase" }}
          placeholder={placeholder}
        />
      </Form.Group>
    </div>
  );

  return (
    <div>
      <center><h3>DATOS DE LA UNIDAD</h3></center>
      <div className="row">
        {field("Modelo Tracto", modelot, setModelot, true, "Ingrese modelo del tracto")}
        {field("Marca Tractor", marcat, setMarcat, true, "Ingrese marca del tractor")}
        {field("Color Tractor", colort, setColort, true, "Ingrese color del tractor")}
        {field("Placa Tractor", placat, setPlacat, true, "Ingrese placa del tractor")}
        <div className="col col-12 col-sm-12 col-md-4">
          <Form.Group label={<div>Tipo plataforma<label className="font-weight-bold text-danger">*</label></div>}>
            <Select
              value={contenedorSize}
              onChange={setContenedorSize}
              options={remolquesTipo}
              placeholder="Seleccione tipo de plataforma"
            />
          </Form.Group>
        </div>
        {field("Económico (Tracto)", economicot, setEconomicot, true, "Ingrese número económico del tracto")}
        {field("Placa Remolque", placar, setPlacar, true, "Ingrese placa del remolque")}
        {field("Económico (Remolque)", economicor, setEconomicor, true, "Ingrese número económico del remolque")}
        {field("Observaciones", observaciones, setObservaciones, false, "Observaciones adicionales")}
      </div>

      <center><h3>OPERADOR</h3></center>
      <div className="row">
        {field("Nombre Operador", nombreOperador, setNombreOperador, true, "Ingrese nombre completo del operador")}
        {field("Medio Contacto", medioContacto, setMedioContacto, true, "Teléfono o correo del operador")}
        {field("Licencia", licencia, setLicencia, false, "Número de licencia")}
      </div>

      <div className="text-center mt-3 mb-3">
        <Button color="primary" onClick={guardar} disabled={saving}>
          {saving ? "Guardando..." : (patioId ? "Actualizar" : "Registrar")}
        </Button>
      </div>
    </div>
  );
};

export default ModalMovimientoPatio;
